import { lazy } from 'react'

export const PerfectSolutionV1 = lazy(() => import('./v1/PerfectSolutionV1'))
export const PerfectSolutionV2 = lazy(() => import('./v2/PerfectSolutionV2'))
export const PerfectSolutionV3 = lazy(() => import('./v3/PerfectSolutionV3'))
